import { AllFTUXes, initialFTUXDictionary } from '@aloft/toolkit-shared';

const getItem = (key: string) => parseInt(window.localStorage.getItem(key) ?? '0');

export const migrateFTUXFromLocalStorage = (): AllFTUXes => ({
  'autoHelpDrawer-properties':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-properties') ??
    initialFTUXDictionary['autoHelpDrawer-properties'],
  'autoHelpDrawer-market-conditions':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-market-conditions') ??
    initialFTUXDictionary['autoHelpDrawer-market-conditions'],
  'autoHelpDrawer-replacement-cost':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-replacement-cost') ??
    initialFTUXDictionary['autoHelpDrawer-replacement-cost'],
  'autoHelpDrawer-depreciation-and-site':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-depreciation-and-site') ??
    initialFTUXDictionary['autoHelpDrawer-depreciation-and-site'],
  'autoHelpDrawer-summary':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-summary') ?? initialFTUXDictionary['autoHelpDrawer-summary'],
  'autoHelpDrawer-adjustments-summary':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-adjustments-summary') ??
    initialFTUXDictionary['autoHelpDrawer-adjustments-summary'],
  'autoHelpDrawer-commentary-summary':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-commentary-summary') ??
    initialFTUXDictionary['autoHelpDrawer-commentary-summary'],
  'autoHelpDrawer-cost-appr-summary':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-cost-appr-summary') ??
    initialFTUXDictionary['autoHelpDrawer-cost-appr-summary'],
  'autoHelpDrawer-paired-sales-library':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-paired-sales-library') ??
    initialFTUXDictionary['autoHelpDrawer-paired-sales-library'],
  'autoHelpDrawer-paired-sales-search-and-adjust':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-paired-sales-search-and-adjust') ??
    initialFTUXDictionary['autoHelpDrawer-paired-sales-search-and-adjust'],
  'autoHelpDrawer-analysis':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-analysis') ??
    initialFTUXDictionary['autoHelpDrawer-analysis'],
  'autoHelpDrawer-adjustments':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-adjustments') ??
    initialFTUXDictionary['autoHelpDrawer-adjustments'],
  'autoHelpDrawer-commentary':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-commentary') ??
    initialFTUXDictionary['autoHelpDrawer-commentary'],
  'autoHelpDrawer-craftsman-cost-approach':
    getItem('FTUX_AUTO_HELP_DRAWER_KEY-craftsman-cost-approach') ??
    initialFTUXDictionary['autoHelpDrawer-craftsman-cost-approach'],
  replacementCostInputFocus:
    getItem('FTUX_REPLACEMENT_COST_INPUT_FOCUS_KEY') ??
    initialFTUXDictionary.replacementCostInputFocus,

  // keys from after local storage:
  analysisIntroTour: initialFTUXDictionary.analysisIntroTour, // post-
});
